import {Routes} from '@angular/router';
import {PAGE_TITLE} from "./constants/constants";

export const routes: Routes = [
    {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent),
        title: `Qeleo - ${PAGE_TITLE.HOME}`
    },
    // {
    //     path: 'products',
    //     loadComponent: () => import('./pages/products/products.component').then(c => c.ProductsComponent),
    //     title: `Qeleo - ${PAGE_TITLE.PRODUCTS}`
    // },
    {
        path: 'consultancy',
        loadComponent: () => import('./pages/consultancy/consultancy.component').then(c => c.ConsultancyComponent),
        title: `Qeleo - ${PAGE_TITLE.CONSULTANCY}`
    },
    {
        path: 'pricing',
        loadComponent: () => import('./pages/pricing/pricing.component').then(c => c.PricingComponent),
        title: `Qeleo - ${PAGE_TITLE.PRICING}`
    },
    {
        path: 'insights',
        loadChildren: () => import('./pages/insights/insights.routes').then(r => r.INSIGHTS_ROUTES),
        title: `Qeleo - ${PAGE_TITLE.INSIGHTS}`,
    },
    // {
    //     path: 'investor',
    //     loadComponent: () => import('./pages/investor-relations/investor-relations.component').then(c => c.InvestorRelationsComponent),
    //     title: `Qeleo - ${PAGE_TITLE.INVESTOR_RELATIONS}`
    // },
    {
        path: 'about',
        loadComponent: () => import('./pages/about/about.component').then(c => c.AboutComponent),
        title: `Qeleo - ${PAGE_TITLE.ABOUT}`
    },
    {
        path: 'ethics',
        loadComponent: () => import('./pages/ethics/ethics.component').then(c => c.EthicsComponent),
        title: `Qeleo - ${PAGE_TITLE.ETHICS}`
    },
    {
        path: 'legal',
        loadComponent: () => import('./pages/legal/legal.component').then(c => c.LegalComponent),
        title: `Qeleo - ${PAGE_TITLE.LEGAL}`
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
    }, // Redirect to home on root path
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'home'
    }, // Handle other unmatched routes (optional)
];
